module.exports = "<div #mainContainer class=\"main-container\">\r\n  <div class=\"biddle-container\">\r\n     <app-engine></app-engine>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// D:/Work/Biddle/biddle-training-module/biddle-training-admin/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main